import React, { FC } from 'react'
import { Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons'

export const AccessDenied: FC<{}> = () => {
  const { t } = useTranslation()
  return (
    <>
      <Helmet>
        <title>Gateway [{t('accessdenied')}]</title>
      </Helmet>
      <Col className=' mx-auto contain'>
        <div className='content'>
          <h1 className='mb-5'>
            <FontAwesomeIcon icon={faEyeSlash} /> {t('accessdenied')}
          </h1>
          <h1>Your account does not have any permissions assigned to it.</h1>
          <h1>Please contact your administrator.</h1>
        </div>
      </Col>
    </>
  )
}
